const categoriesModule = {
  id: "203d87ca-4879-31b8-bc2d-7d2bccc50c81",
  config: {
    general: {
      template: {
        label: "Tower",
        component: "CategoriesTower",
      },
      categories: [
        {
          id: "ba86e063-fc88-5c54-ac5b-202240572f44",
          isEnabled: true,
          jobs: 22,
          jobsText: "22 jobs",
          title: "Marketing & Communication",
          url: "https://www.google.de",
        },
        {
          id: "ba86e063-fc88-5c54-ac5b-202240572f42",
          isEnabled: true,
          jobs: 33,
          jobsText: "33 jobs",
          title: "Accounting & Finance",
          url: "https://www.google.de",
        },
        {
          id: "ba86e063-fc88-5c54-ac5b-202240572f49",
          isEnabled: false,
          jobs: 7,
          jobsText: "7 jobs",
          title: "Core Business Services",
          url: "https://www.google.de",
        },
      ],
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      backgroundColor: {
        label: "White",
        value: "#ffffff",
      },
      textColor: {
        label: "Black",
        value: "#000000",
      },
      showJobCounter: true,
    },
  },
};

export default categoriesModule;
